<div class="select-search" data-test="busca-select">
    <mat-icon data-test="icone-busca-select" class="select-search-icon">search</mat-icon>
    <input #input data-test="campo-busca-select" type="text" autocomplete="off" [value]="term"
        [placeholder]="placeholder || ('selectSearch.placeholder' | translate)"
        (input)="onInput(input.value)" (keydown)="$event.stopPropagation()">
    <button data-test="btn-limpar-busca-select" *ngIf="term" type="button" class="select-search-clear"
        (click)="clear(); input.focus()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div data-test="sem-resultados-select" class="select-search-empty" *ngIf="noResults">{{ noResultsLabel ||
    ('selectSearch.noResults' | translate) }}</div>
